module.exports = __webpack_public_path__ + "img/mountedcrane_driving.8f12fa95.svg";